import React from 'react';
import { ErrorBoundary } from './ErrorBoundary';
import { Settings, RefreshCw } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';

interface NodeEditorErrorBoundaryProps {
  children: React.ReactNode;
  nodeName?: string;
  onClose?: () => void;
}

export const NodeEditorErrorBoundary: React.FC<NodeEditorErrorBoundaryProps> = ({ 
  children, 
  nodeName,
  onClose 
}) => {
  return (
    <ErrorBoundary
      level="section"
      onError={(error, errorInfo) => {
        // Node editor specific error handling
        // Already logged by ErrorBoundary
      }}
      fallback={
        <div className="flex items-center justify-center h-full p-6">
          <Alert variant="destructive" className="max-w-md">
            <Settings className="h-5 w-5" />
            <AlertTitle>Node Editor Error</AlertTitle>
            <AlertDescription className="mt-2">
              <p className="mb-4">
                {nodeName 
                  ? `The editor for "${nodeName}" encountered an error.`
                  : 'The node editor encountered an error and couldn\'t load properly.'
                }
              </p>
              <div className="flex gap-2">
                {onClose && (
                  <Button 
                    size="sm" 
                    variant="outline" 
                    onClick={onClose}
                  >
                    Close Editor
                  </Button>
                )}
                <Button 
                  size="sm" 
                  variant="outline" 
                  onClick={() => window.location.reload()}
                >
                  <RefreshCw className="mr-2 h-4 w-4" />
                  Reload Page
                </Button>
              </div>
            </AlertDescription>
          </Alert>
        </div>
      }
    >
      {children}
    </ErrorBoundary>
  );
};
